import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Api from '../../Services/Api';
import Alert from '../../Services/Alert';
import { mergePermissions } from './permissionModules';
import PermissionMatrix from './PermissionMatrix';

export const SubAdminEdit = () => {
    const history = useHistory();
    const { id } = useParams();
    const [tab, setTab] = useState('account');
    const [form, setForm] = useState({ firstname: '', lastname: '', email: '', password: '' });
    const [permissions, setPermissions] = useState(mergePermissions({}));
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        Api.get('roles/sub-admins/' + id).then((r) => r.data).then((res) => {
            if (res.status == 1) {
                const d = res.data;
                setForm({ firstname: d.firstname || '', lastname: d.lastname || '', email: d.email || '', password: '' });
                setPermissions(mergePermissions(d.permissions));
            } else { Alert.error(res.message); }
        });
    }, [id]);

    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    function save() {
        if (!/\S+@\S+\.\S+/.test(form.email)) return Alert.error('A valid email is required');
        if (form.password && form.password.length < 6) return Alert.error('Password must be at least 6 characters');
        setSaving(true);
        Api.post('roles/sub-admins/update', {
            id, firstname: form.firstname, lastname: form.lastname, email: form.email, password: form.password, permissions
        }).then((r) => r.data).then((res) => {
            setSaving(false);
            if (res.status == 1) { Alert.success(res.message); history.push('/roles/sub-admins'); }
            else { Alert.error(res.message); }
        }).catch(() => setSaving(false));
    }

    return (
        <section className="main-content">
            <div className="page-content"><div className="container-fluid"><div className="row"><div className="col-lg-10">
                <div className="card"><div className="card-body">
                    <h4 className="card-title mb-3">Edit Sub-Admin</h4>
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item"><a className={'nav-link ' + (tab === 'account' ? 'active' : '')} href="#account" onClick={(e) => { e.preventDefault(); setTab('account'); }}>Account Info</a></li>
                        <li className="nav-item"><a className={'nav-link ' + (tab === 'permissions' ? 'active' : '')} href="#permissions" onClick={(e) => { e.preventDefault(); setTab('permissions'); }}>Permissions</a></li>
                    </ul>
                    {tab === 'account' && (
                        <div style={{ maxWidth: 460 }}>
                            <div className="form-group mb-3"><label>First Name</label><input className="form-control" name="firstname" value={form.firstname} onChange={onChange} /></div>
                            <div className="form-group mb-3"><label>Last Name</label><input className="form-control" name="lastname" value={form.lastname} onChange={onChange} /></div>
                            <div className="form-group mb-3"><label>Email</label><input className="form-control" type="email" name="email" value={form.email} onChange={onChange} /></div>
                            <div className="form-group mb-3"><label>New Password <small className="text-muted">(leave blank to keep current)</small></label><input className="form-control" type="password" name="password" value={form.password} onChange={onChange} /></div>
                        </div>
                    )}
                    {tab === 'permissions' && <PermissionMatrix permissions={permissions} setPermissions={setPermissions} />}
                    <div className="mt-3">
                        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</button>
                        <button className="btn btn-link" onClick={() => history.push('/roles/sub-admins')}>Cancel</button>
                    </div>
                </div></div>
            </div></div></div></div>
        </section>
    );
};
export default SubAdminEdit;
